/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PartialDischarges { 
    number_of_partdischarges?: number;
    time_between_partdischarges?: number;
    discharge_amount?: number;
}

